import { Mark, mergeAttributes, markInputRule, markPasteRule } from '@tiptap/core';
var inputRegex = /(?:^|\s)((?:`)((?:[^`]+))(?:`))$/;
var pasteRegex = /(?:^|\s)((?:`)((?:[^`]+))(?:`))/g;
var Code = Mark.create({
  name: 'code',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: '_',
  code: true,
  parseHTML: function parseHTML() {
    return [{
      tag: 'code'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['code', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      setCode: function setCode() {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.setMark(_this.name);
        };
      },
      toggleCode: function toggleCode() {
        return function (_ref3) {
          var commands = _ref3.commands;
          return commands.toggleMark(_this.name);
        };
      },
      unsetCode: function unsetCode() {
        return function (_ref4) {
          var commands = _ref4.commands;
          return commands.unsetMark(_this.name);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;

    return {
      'Mod-e': function ModE() {
        return _this2.editor.commands.toggleCode();
      }
    };
  },
  addInputRules: function addInputRules() {
    return [markInputRule({
      find: inputRegex,
      type: this.type
    })];
  },
  addPasteRules: function addPasteRules() {
    return [markPasteRule({
      find: pasteRegex,
      type: this.type
    })];
  }
});
export { Code, Code as default, inputRegex, pasteRegex };